

















































































import {Component, Emit, Prop, PropSync} from "vue-property-decorator";
import {Warehouse} from "@/interfaces/entity";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import moment from "moment";
import {WarehouseStore} from "@/modules/warehouses/store";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {LadingType} from "@/enums/type";
import LadingTypeLabel from "@/modules/ladings/List/components/TypeLabel.vue";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: "WarehouseTable",
    components: {TooltipLabel, LadingTypeLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @PropSync("dataSource", {required: true}) syncDataSource!: Array<Warehouse>;
    @PropSync("selectedIds", {type: Array}) syncSelectedIds!: Array<number>;
    @Prop({type: Boolean, default: false}) readonly hasRowSelection!: boolean;
    @Prop({type: Boolean, default: false}) readonly hasAction!: boolean;

    moment = moment;
    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50,
            fixed: 'left'
        },
        {
            title: "Mã vận đơn",
            dataIndex: "ladingRowGuid",
            key: "ladingCode",
            scopedSlots: {customRender: "ladingCode"},
            width: 150,
            fixed: 'left',
            ellipsis: true
        },
        {
            title: "Ngày nhập kho",
            dataIndex: "createdDate",
            key: "createdDate",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "createdDate"}
        },
        {
            title: "BC chấp nhận",
            dataIndex: "ladingRowGuid",
            key: "acceptancePostOffice",
            scopedSlots: {customRender: "acceptancePostOffice"},
            width: 150,
            ellipsis: true
        },
        {
            title: "BC phát",
            dataIndex: "ladingRowGuid",
            key: "deliveryPostOffice",
            scopedSlots: {customRender: "deliveryPostOffice"},
            width: 180,
            ellipsis: true
        },
        // {
        //     title: "Tuyến phát",
        //     dataIndex: "ladingRowGuid",
        //     key: "deliveryEmployee",
        //     scopedSlots: {customRender: "deliveryEmployee"},
        //     width: 180
        // },
        // {
        //     title: "Mã khách hàng",
        //     dataIndex: "ladingRowGuid",
        //     key: "customerCode",
        //     scopedSlots: {customRender: "customerCode"},
        //     width: 150
        // },
        // {
        //     title: "Tên khách hàng",
        //     dataIndex: "ladingRowGuid",
        //     key: "customerName",
        //     scopedSlots: {customRender: "customerName"},
        //     width: 200,
        //     ellipsis: true
        // },
        // {
        //     title: "SDT người nhận",
        //     dataIndex: "ladingRowGuid",
        //     key: "locationToPhone",
        //     scopedSlots: {customRender: "locationToPhone"},
        //     width: 200
        // },
        // {
        //     title: "Tên người nhận",
        //     dataIndex: "ladingRowGuid",
        //     key: "locationToName",
        //     scopedSlots: {customRender: "locationToName"},
        //     width: 200
        // },
        {
            title: "Địa chỉ giao hàng",
            dataIndex: "ladingRowGuid",
            key: "locationToAddress",
            scopedSlots: {customRender: "locationToAddress"},
            width: 500,
            ellipsis: true
        },
        {
            title: "Loại bưu gửi",
            dataIndex: "ladingRowGuid",
            key: "ladingBoxContent",
            scopedSlots: {customRender: "ladingBoxContent"},
            width: 120,
            ellipsis: true
        },
        {
            title: "TL",
            dataIndex: "ladingRowGuid",
            key: "ladingWeight",
            scopedSlots: {customRender: "ladingWeight"},
            width: 100,
            ellipsis: true
        },
        {
            title: "SK",
            dataIndex: "ladingRowGuid",
            key: "ladingBoxQuantity",
            scopedSlots: {customRender: "ladingBoxQuantity"},
            width: 50,
            ellipsis: true
        },
        // {
        //     title: "Dịch vụ",
        //     dataIndex: "ladingRowGuid",
        //     key: "ladingFreightService",
        //     scopedSlots: {customRender: "ladingFreightService"},
        //     width: 100
        // },
        // {
        //     title: "DV_GTGT",
        //     dataIndex: "ladingRowGuid",
        //     key: "ladingFreightServiceAdds",
        //     scopedSlots: {customRender: "ladingFreightServiceAdds"},
        //     width: 120
        // },
        {
            title: "Thu tiền NN",
            dataIndex: "ladingRowGuid",
            key: "receiverCollect",
            scopedSlots: {customRender: "receiverCollect"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "ladingRowGuid",
            key: "ladingStatus",
            scopedSlots: {customRender: "ladingStatus"},
            width: 240,
            ellipsis: true
        },
        {
            title: "GDV nhập kho",
            dataIndex: "createdBy",
            key: "createdBy",
            scopedSlots: { customRender: "createdBy" },
            width: 150,
            ellipsis: true
        },
        // {
        //     title: "Loại đơn",
        //     dataIndex: "billLading.type",
        //     key: "billLadingType",
        //     scopedSlots: {customRender: "billLadingType"},
        //     width: 150,
        //     ellipsis: true
        // },
    ];
    LadingType = LadingType;

    get rowSelection() {
        return {selectedRowKeys: this.syncSelectedIds, onChange: this.onSelectChange};
    }

    onSelectChange(selectedRowKeys: any) {
        this.syncSelectedIds = selectedRowKeys;
    }

    get pagination(): object {
        return {
            current: WarehouseStore.meta?.page,
            pageSize: WarehouseStore.meta?.limit,
            total: WarehouseStore.meta?.total,
            showTotal: (total: number) => `Tổng cộng ${total} vận đơn`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    @Emit("onChangePage")
    onChangePage(pagination: any) {
        return pagination;
    }
}
